export default __webpack_public_path__ + "static/pets-and-you-logo-6f032625aa85ed3fef7cfef2fb28a80a.png";